module.exports = __webpack_public_path__ + "img/icon-tool.5bd618bd.svg";